import * as types from './mutation-types'

const namespaced = true

const initialState = {
    list: [],
    dates: [],
    // hard coding current date for general races / quick hack for dealing with senate runoff
    currentDate: {
        senate: '2020-11-03',
        house: '2020-11-03',
        president: '2020-11-03',
        senateRunoff: '2021-01-05'
    }
}

const mutations = {
    [types.PUT_AGGREGATE_MODELS](state, models) {
        state.list = models
    },
    [types.SET_DATES](state, dates) {
        state.dates = dates
    },
    [types.SET_CURRENT_DATE](state, { date, chamber }) {
        state.currentDate[chamber] = date
    }
}

const actions = {
    async list(context) {
        await fetch("https://forecasting-data.decisiondeskhq.com/2020/prod/aggregateModels.json")
            .then(response => response.json())
            .then(data => {
                const models = data;
                context.commit(types.PUT_AGGREGATE_MODELS, data);
                // hard coding current date for general races / quick hack for dealing with senate runoff
                const dates = models.filter(model => model.chamber === 'SENATE (R)').map(model => model.date)
                    .filter(d => d)
                    .reduce((x, y) => x.includes(y) ? x : [...x, y], [])
                dates.sort((a, b) => {
                    return a.localeCompare(b)
                })
                context.commit(types.SET_DATES, dates)
                if (!context.state.currentDate['senateRunoff']) {
                    context.commit(types.SET_CURRENT_DATE, { date: dates[dates.length - 1], chamber: 'senateRunoff' })
                }
                return models
            })
            .catch(error => console.error(error));
    },
}

const getters = {
    list(state) {
        return state.list
    },
    dates(state) {
        return state.dates
    },
    currentDate: (state) => (chamber) => {
        return state.currentDate[chamber]
    }
}

export default {
    namespaced,
    state: initialState,
    mutations,
    actions,
    getters
}
